import { render, staticRenderFns } from "./applicant-master-data.vue?vue&type=template&id=2dfa443c&scoped=true"
import script from "./applicant-master-data.vue?vue&type=script&lang=js"
export * from "./applicant-master-data.vue?vue&type=script&lang=js"
import style0 from "./applicant-master-data.vue?vue&type=style&index=0&id=2dfa443c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dfa443c",
  null
  
)

export default component.exports